import { renderSlot as _renderSlot, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1b668458"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "label" }
const _hoisted_2 = { class: "label--body" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Some text")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _renderSlot(_ctx.$slots, "image", {}, undefined, true),
    _createElementVNode("p", _hoisted_2, [
      _renderSlot(_ctx.$slots, "default", {}, () => [
        _hoisted_3
      ], true)
    ])
  ]))
}